module.exports = function(vars) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div>\n  <div class="player_img_thumb_wrap">\n    <img class="owl-lazy img_player_thumb"\n    src="//cdn2.streamspot.com/streamspot-od-w-circles-160x90.png" data-src="' +
__e( vars.thumbnailLink ) +
'"\n    alt="' +
__e( vars.titleForAria ) +
' archive" aria-label="' +
__e( vars.titleForAria ) +
' archive" />\n    <div class="player_img_meta">\n			<span class="label label-default archive-duration-label">' +
__e( vars.vidDur ) +
'</span>\n    </div>\n  </div>\n	<div class="mobile-meta">\n		';
 if ( vars.custom_name ){
			;
__p +=
__e( vars.custom_name ) +
'<br>';

		} ;
__p +=
__e( vars.date ) +
'<br>' +
__e( vars.time ) +
'\n	</div>\n</div>\n';
return __p
}


// WEBPACK FOOTER //
// ./src/templates/video-list-item.ejs